import React from 'react';

import { Box, HStack, Center } from '@chakra-ui/react';

import { DeleteActionButton, PageInfo } from 'app/components';
import { ActionButton, EditIcon } from 'app/components';

export const renderActions = ({ row, onEdit, onDelete, userCount = 1 }) => {
  const saasRootAdmin =
    row.organization === 'master' && row.username === 'admin';
  return (
    <HStack spacing={0}>
      <Center w="full">
        <ActionButton
          label="Edit"
          icon={<EditIcon />}
          onClick={() => onEdit(row)}
          isDisabled={saasRootAdmin}
        />
        <DeleteActionButton
          onConfirm={onDelete.bind(this, row)}
          isDisabled={
            saasRootAdmin ||
            userCount === 1 ||
            row?.operations?.delete?.allowed === false
          }
          name={row?.username}
          type="user"
          label={<Box maxW={200}>{row?.operations?.delete?.reason}</Box>}
        />
      </Center>
    </HStack>
  );
};

export const isMasterOrg = ({ orgName }) => {
  return orgName === 'master';
};

// The users API returns every user at once, so the table pages them on the
// client: return the rows for the current page.
export const getPageRows = <T,>(
  rows: T[],
  { page_number, page_size }: PageInfo,
): T[] => rows.slice((page_number - 1) * page_size, page_number * page_size);
